"use client";
import Image from "next/image";
import React, { useState, useEffect } from "react";
import reactionAPI from "@/services/reaction_api";
import { definitions } from "@/services/metruyenvl";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "@/redux/store";
import { useAuth } from "@/hooks";
import { showModalForm } from "@/redux/reducers/user.reducer";
import { ResponseTypes } from "@/types/constants";
import { statAPI } from "@/services/stat_api";
import { userActionAPI } from "@/services/user_action_api";

function ReactionBooks({ book, userAction }: { book: definitions["do.BookDO"]; userAction: definitions["do.UserActionDO"] }) {
    const [isHovered, setIsHovered] = useState(false);
    const { isAuth } = useAuth();

    // const [userAction, setUserAction] = useState<definitions["do.UserActionDO"]>();

    // const getUserAction = async () => {
    //     console.log("ReactionBooks getUserAction 1");
    //     try {
    //         const res: ResponseTypes = await userActionAPI.getUserAction("book", book.id as string);
    //         setUserAction(res.data);
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    // useEffect(() => {
    //     if (isAuth) {
    //         getUserAction();
    //     }
    // }, [book]);

    const dispatch = useDispatch<AppDispatch>();
    const handleHover = () => {
        setIsHovered(true);
    };

    const iconSize = 75;
    const handleMouseLeave = () => {
        setIsHovered(false);
    };
    const postReaction = async (type: definitions["models.ReactionType"]) => {
        setIsHovered(false);
        if (isAuth) {
            try {
                const res = await reactionAPI.postReaction("book", book.id as "", type);
            } catch (error) {
                console.log(error);
            }
        } else {
            dispatch(showModalForm(true));
        }
    };
    const switchReact = () => {
        switch (userAction?.reaction_used) {
            case "like":
                return <Image width={iconSize} unoptimized={true} height={iconSize} className="reactButton" style={{ backgroundColor: "#fff" }} src="/like.gif" alt="Like emoji" />;
            case "love":
                return <Image width={iconSize} unoptimized={true} height={iconSize} className="reactButton" style={{ backgroundColor: "#fff" }} src="/love.gif" alt="Like emoji" />;
            case "lol":
                return <Image width={iconSize} unoptimized={true} height={iconSize} className="reactButton" style={{ backgroundColor: "#fff" }} src="/haha.gif" alt="Like emoji" />;
            case "wow":
                return <Image width={iconSize} unoptimized={true} height={iconSize} className="reactButton" style={{ backgroundColor: "#fff" }} src="/wow.gif" alt="Like emoji" />;
            case "sad":
                return <Image width={iconSize} unoptimized={true} height={iconSize} className="reactButton" style={{ backgroundColor: "#fff" }} src="/sad.gif" alt="Like emoji" />;
            case "angry":
                return <Image width={iconSize} unoptimized={true} height={iconSize} className="reactButton" style={{ backgroundColor: "#fff" }} src="/angry.gif" alt="Like emoji" />;
            default:
                return <Image width={iconSize} unoptimized={true} height={iconSize} className="reactButton" style={{ backgroundColor: "#fff" }} src="/like.gif" alt="Like emoji" />;
        }
    };
    return (
        <div onMouseEnter={handleHover} onMouseLeave={handleMouseLeave} className="bt_like" style={{ position: "relative", display: "inline-block" }}>
            <div className="w-full flex justify-center"> {switchReact()}</div>
            {/* <Image width={iconSize} height={iconSize} className="reactButton" style={{ backgroundColor: "#fff" }} src="/like.gif" alt="Like emoji" /> */}
            {isHovered && (
                <div className="list_emotion md:w-96 md:top-0 top-1 left-5 z-50 bg-white" style={{ position: "absolute", border: "1px solid green", borderRadius: "50px" }}>
                    <div className="flex items-center justify-between cursor-pointer">
                        <Image
                            onClick={() => {
                                postReaction("like");
                            }}
                            unoptimized={true}
                            width={iconSize}
                            height={iconSize}
                            className="reactButton ease-in duration-75 hover:scale-150 object-cover w-10 h-10 md:w-16 md:h-16"
                            src="/like.gif"
                            alt="Like emoji"
                        />
                        <Image
                            onClick={() => {
                                postReaction("love");
                            }}
                            unoptimized={true}
                            width={iconSize}
                            height={iconSize}
                            className="reactButton ease-in duration-75 hover:scale-150 object-cover w-10 h-10 md:w-16 md:h-16"
                            src="/love.gif"
                            alt="Love emoji"
                        />
                        <Image
                            onClick={() => {
                                postReaction("lol");
                            }}
                            unoptimized={true}
                            width={iconSize}
                            height={iconSize}
                            className="reactButton ease-in duration-75 hover:scale-150 object-cover w-10 h-10 md:w-16 md:h-16"
                            src="/haha.gif"
                            alt="Haha emoji"
                        />
                        <Image
                            onClick={() => {
                                postReaction("wow");
                            }}
                            unoptimized={true}
                            width={iconSize}
                            height={iconSize}
                            className="reactButton ease-in duration-75 hover:scale-150 object-cover w-10 h-10 md:w-16 md:h-16"
                            src="/wow.gif"
                            alt="Wow emoji"
                        />
                        <Image
                            onClick={() => {
                                postReaction("sad");
                            }}
                            unoptimized={true}
                            width={iconSize}
                            height={iconSize}
                            className="reactButton ease-in duration-75 hover:scale-150 object-cover w-10 h-10 md:w-16 md:h-16"
                            src="/sad.gif"
                            alt="Sad emoji"
                        />
                        <Image
                            onClick={() => {
                                postReaction("angry");
                            }}
                            unoptimized={true}
                            width={iconSize}
                            height={iconSize}
                            className="reactButton ease-in duration-75 hover:scale-150 object-cover w-10 h-10 md:w-16 md:h-16"
                            src="/angry.gif"
                            alt="Angry emoji"
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default ReactionBooks;
